import Typed from "typed.js";

function initTypingList(){
    for (const list of document.querySelectorAll('.typingList')){
        const strings = list.dataset.strings;

        if(strings !== null){
            new Typed(list, {
                strings: strings.split(","),
                typeSpeed: 40,
                backSpeed: 40,
                backDelay: 4000,
                startDelay: 4000,
                loop: true,
                autoInsertCss: false
            });
        }
    }
}

export default initTypingList;